export enum TipoDeFlagEnum {
  APP = 'APP',
  OFV = 'OFV',
  WEB = 'WEB',
}
